export type SmartLinksStats = {
	fetch: number;
	fetchTimeout: Record<string, number>;
	links: Record<string, Record<string, { total: number; resolved: number; timeout: number }>>;
};

export type SmartLinksCounts = {
	totalLinks: number;
	totalResolved: number;
};

export const getSmartLinksStats = (stats?: SmartLinksStats): SmartLinksCounts => {
	if (!stats) {
		return { totalLinks: 0, totalResolved: 0 };
	}
	const { links } = stats;
	let totalLinks = 0;
	let totalResolved = 0;
	Object.values(links).forEach((byAppearance) => {
		Object.values(byAppearance).forEach(({ total, resolved }) => {
			totalLinks += total;
			totalResolved += resolved;
		});
	});
	return { totalLinks, totalResolved };
};
